import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { TranslationService } from './core/service/app/translate.service';
import { locale as enLang } from './core/config/i18n/en';
import { locale as itLang } from './core/config/i18n/it';
import { FilterChangeService } from './core/service/api/filter-change.service';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { Helpers } from './core/helpers';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    providers:[TranslateService,TranslationService]
})
export class AppComponent implements OnInit, AfterViewChecked, AfterViewInit{
    title:string = 'My Guglielmo Dashboard v2';
    faviconUrl:string = './assets/images/logo/';
    ngOnInit() {
        setTimeout(() => {
            if(Helpers.getBrand()){
                this.setFavicon(this.faviconUrl);
            }else{
            }
        }, 1000);
        this.titleService.setTitle(this.title);
      }
    constructor(
        private translationService: TranslationService,
        private chRef: ChangeDetectorRef,
        private _filterDataChangeService:FilterChangeService,
        private titleService: Title) {
        // Set user's browser language if it's the first vist
        if (!localStorage.getItem('language')) {
            const userLang = navigator.language.substring(0, 2).toLowerCase();
            localStorage.setItem('language', userLang);
            this.translationService.setLanguage(userLang);
        } else {
            this.translationService.setLanguage(localStorage.getItem('language') || '');
        }
        // register translations
        this.translationService.loadTranslations(enLang, itLang);
    }

    setFavicon(url: string) {
        const favicon = document.getElementById('appFavicon') as HTMLLinkElement;
        if (favicon) {
            switch (Helpers.getBrand()) {
                case "SISTELO":
                    favicon.href = url + "sistelo.svg";
                    break;
                case "LUMEN":
                    favicon.href = url + "lumen.png";
                    break;
                default:
                    favicon.href = url + "guglielmo.png";
                    break;
            }
        }
    }


    ngAfterViewChecked() {
		// register translations
		this.translationService.loadTranslations(enLang, itLang);
		this.chRef.detectChanges();
	}

    ngAfterViewInit() {
		// register translations
		this.translationService.loadTranslations(enLang, itLang);
		this.chRef.detectChanges();
    }



}
